import React from 'react';
import PropTypes from 'prop-types';
import TextInput from 'utils/components/text-input';

class TextField extends React.Component {
  renderMessage() {
    if (!this.props.validation || this.props.validation.status === 'none') {
      return null;
    }

    var hasError = this.props.validation.status === 'error';
    var message = this.props.validation.message;

    return (
      <div className={'validation ' + (hasError ? 'validation-error' : 'validation-success')}>
        <i className={'icon ' + (hasError ? 'error-icon' : 'success-icon')} />
        <span className="text">{message}</span>
      </div>
    );
  }

  focus() {
    this.refs.textInput.focus();
  }
  render() {
    var message = null;
    if (!this.props.showValidationTooltip) {
      message = this.renderMessage();
    }

    var description = null;
    if (this.props.description) {
      description = <div className="field-description">{this.props.description}</div>;
    }

    var title = null;
    if (this.props.title) {
      title = <div className="field-title">{this.props.title}</div>;
    }

    var input = <TextInput {...this.props} ref="textInput" />;

    var wrapper = this.props.wrapper;
    if (wrapper) {
      input = <div className="input-wrapper">{input}</div>;
    }
    let className = 'field';
    if (this.props.fieldClassName) {
      className += ` ${this.props.fieldClassName}`;
    }
    return (
      <div className={className}>
        {title}
        {description}
        {message}
        {input}
      </div>
    );
  }
}

TextField.propTypes = {
  fieldClassName: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  showValidationTooltip: PropTypes.bool,
  wrapper: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  validation: PropTypes.shape({
    message: PropTypes.string,
    status: PropTypes.oneOf(['error', 'success', 'none'])
  }),
  name: PropTypes.string
};

TextField.displayName = 'TextField';

export default TextField;
